




import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnStatics, AcgnStaticsMenu } from '@/components';

// 组件申明
@Component({
  components: {
    AcgnStatics,
    AcgnStaticsMenu
  },
  mixins: [RenderMenuMixin]
})

/**
 * 数据总览
 */
export default class Statistic extends Vue {
  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="index"></acgn-statics-menu>
    );
  }
}
